import React from 'react';

import { List } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  deleteDefecation,
  deleteDrug,
  deleteMeal,
  deleteMilk,
  deleteSleep,
  deleteTemperature,
} from '../thunk';

import LineButtons from './LineButtons';

import type { HealthRecords } from '@/domain/childNotebook/component/HealthInfo';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { HealthRecordTypeType } from '@/types/domain/class/valueObjects/healthRecordType';
import type { UserType } from '@/types/domain/user/redux';

import HealthInfo from '@/domain/childNotebook/component/HealthInfo';

/** プロパティ */
export type HealthRecordViewInput = {
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 本日の健康記録 */
  healthRecords: HealthRecords,
  /** 表示対象 */
  healthRecordTypes: HealthRecordTypeType[],
  /** 日付 */
  date: string,
};

const HealthRecordView: React.FC<HealthRecordViewInput> = ({
  user,
  child,
  facilityList,
  healthRecords,
  healthRecordTypes,
  date,
}) => {
  const dispatch = useDispatch();
  const facilityIds = facilityList.map((v) => v.data.facilityId);
  const isYesterdaySleep = !healthRecords.sleeps[0]?.data.isSleepTime;
  // 表示物一覧作成
  const deleteFuncs = {
    temperature: healthRecords.temperatures.map(
      (v) => (() => { dispatch(deleteTemperature({ data: v, facilityIds })); }),
    ),
    sleep: healthRecords.sleeps.map(
      (v) => (() => { dispatch(deleteSleep({ data: v, facilityIds })); }),
    ),
    defecation: healthRecords.defecations.map(
      (v) => (() => { dispatch(deleteDefecation({ data: v, facilityIds })); }),
    ),
    milk: healthRecords.milks.map(
      (v) => (() => { dispatch(deleteMilk({ data: v, facilityIds })); }),
    ),
    meal: healthRecords.meals.map(
      (v) => (() => { dispatch(deleteMeal({ data: v, facilityIds })); }),
    ),
    drug: healthRecords.drugs.map(
      (v) => (() => { dispatch(deleteDrug({ data: v, facilityIds })); }),
    ),
  };
  return (
    <>
      <List>
        <HealthInfo
          date={date}
          healthRecords={healthRecords}
          healthRecordTypes={healthRecordTypes}
          deleteFuncs={deleteFuncs}
        />
      </List>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          width: '100%',
        }}
      >
        <LineButtons
          date={date}
          user={user}
          child={child}
          facilityList={facilityList}
          healthRecordTypes={healthRecordTypes}
          isYesterdaySleep={isYesterdaySleep}
        />
      </div>
    </>
  );
};

export default HealthRecordView;
